export default (plansBackendCollection) => ({
  plans: plansBackendCollection,
  activeCycle: "MONTHLY", // Default selected recurrence billing cycle

  init() {
    // Component bootstrap lifecycle hook if needed
  },

  /**
   * Internal helper to fetch the exact price object based on active cycle.
   */
  _getCyclePriceObject(planSlug) {
    const plan = this.plans.find((p) => p.slug === planSlug);
    if (!plan || !plan.prices) return null;

    return plan.prices.find((p) => p.cycle === this.activeCycle);
  },

  /**
   * Calculates and formats the equivalent monthly price for display.
   * Divides the total by 6 or 12 for visual anchoring.
   */
  getDisplayMonthlyPrice(planSlug) {
    const cyclePrice = this._getCyclePriceObject(planSlug);
    if (!cyclePrice) return "R$ 0,00";

    let displayValue = cyclePrice.price;

    if (this.activeCycle === "SEMIANNUALLY") {
      displayValue = cyclePrice.price / 6;
    } else if (this.activeCycle === "YEARLY") {
      displayValue = cyclePrice.price / 12;
    }

    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(displayValue);
  },

  /**
   * Generates the transparency subtext indicating the actual total billed.
   */
  getBillingSubtext(planSlug) {
    const cyclePrice = this._getCyclePriceObject(planSlug);
    if (!cyclePrice) return "";

    const formattedTotal = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(cyclePrice.price);

    if (this.activeCycle === "SEMIANNUALLY") {
      return `faturado ${formattedTotal} a cada 6 meses`;
    }

    if (this.activeCycle === "YEARLY") {
      return `faturado ${formattedTotal} anualmente`;
    }

    return "cobrado mês a mês";
  },

  /**
   * Computes a safe dynamic registration URI.
   * Only the structural parameters are sent, never the raw currency values.
   */
  getCheckoutUrl(planSlug) {
    return `/cadastro?plano=${planSlug}&cycle=${this.activeCycle}`;
  },
});
